module.exports = __webpack_public_path__ + "static/media/arrow-menu.9dfe93d8.svg";